import { PercentPipe } from '@angular/common';
import { LOCALE_ID, Pipe, PipeTransform, inject } from '@angular/core';

@Pipe({
  name: 'twoDecimalPercent',
  pure: true,
})
export class TwoDecimalPercentPipe implements PipeTransform {
  private readonly percent = new PercentPipe(inject(LOCALE_ID));

  transform(value: string | number | null | undefined): string {
    try {
      const res = this.percent.transform(value, '1.2-2');
      return res ?? '';
    } catch {
      return '';
    }
  }
}
